import { render, staticRenderFns } from "./AnalysisQuizScore.vue?vue&type=template&id=2a49c87e"
import script from "./AnalysisQuizScore.vue?vue&type=script&lang=js"
export * from "./AnalysisQuizScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports